<template>
  <v-container fluid>

    <v-card class="mb-4">
      <v-card-title class="d-flex justify-space-between align-center">
        <div>
          Custom Presentations
        </div>
        <v-btn @click.prevent="updateAllSlideDecks"
               color="primary">
          Update All Presentations
        </v-btn>
      </v-card-title>
      <v-card-text>
        These have slides from this presentation.
      </v-card-text>
      <v-data-table :items="decks"
                    :headers="headers"
                    :items-per-page="-1"
                    hide-default-footer>
        <template v-slot:item.owner.slug="{item: deck}">
          {{ deck.owner?.name }}
        </template>
        <template v-slot:item.slug="{item: deck}">
          <a :href="`/admin/presentations/${deck.id}`"
             target="_blank">
            {{ deck.name }}
          </a>
        </template>
        <template v-slot:item.created_at="{item: deck}">
          {{ deck.created_at | datetime('YYYY-MM-DD') }}
        </template>
        <template v-slot:item.actions="{item: deck}">
          <v-btn @click.prevent="updateSlideDeck(deck.id)"
                 x-small>
            Update
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import slideDeckService from '../../services/slideDeckService';
import {orderBy} from 'lodash';

export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      decks: [],
      slides: [],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'User',
          value: 'owner.slug',
          sortable: true,
        },
        {
          text: 'Name',
          value: 'slug',
          sortable: true,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
        },
        {
          text: 'Created',
          value: 'created_at',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        }
      ]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.slides = await slideDeckService.getSlidesForPresentation(this.presentation.id)

      const decks = await slideDeckService.getSlideDecksWithSlidesFrom(this.presentation.id)
      this.decks = orderBy(decks, ['owner.name', 'name'], ['asc', 'asc']);
    },
    async updateAllSlideDecks() { // MLD-7331
      try {
        await slideDeckService.updateAllFrom(this.presentation.id)
        this.$toast.success('Updating all of these custom presentations.');
        await this.fetchData();
      } catch (e) {
        this.$toast.error('There was an error updating all custom presentations.');
      }
    },
    async updateSlideDeck(presentationID) {
      try {
        await slideDeckService.updateSlideDeck(presentationID)
        this.$toast.success('Updating that custom presentation.');
        await this.fetchData();
      } catch (e) {
        this.$toast.error('There was an error updating that custom presentation.');
      }
    },
  }
}
</script>
